import { useHttpClient } from '@repo/api-client/react';
import {
  SignOutAllResponseSchema,
  type SignOutAllResponse,
} from '@repo/api-client/dtos';
import { useMutation } from '@tanstack/react-query';

import { postJSON } from '../internal/http';

/**
 * Hit `POST /v1/auth/sign-out-all` to revoke every SuperTokens session
 * the current user has open. The server returns the count of sessions
 * revoked; the client side is responsible for clearing its own cached
 * tokens (the SDK's interceptors already do this on the first 401 that
 * follows).
 *
 * This hook deliberately does *not* update the SessionProvider state —
 * that's the caller's job (typically: render a confirm sheet, then
 * route to the sign-in screen on success).
 */
export function useSignOutAll() {
  const http = useHttpClient();

  const mutation = useMutation({
    mutationFn: () => postJSON(http, '/auth/sign-out-all', {}, SignOutAllResponseSchema),
  });

  return {
    signOutAll: mutation.mutateAsync as () => Promise<SignOutAllResponse>,
    loading: mutation.isPending,
    error: mutation.error,
  };
}
